import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integration-languages-settings',
  templateUrl: './integration-languages-settings.component.html',
  styleUrls: ['./integration-languages-settings.component.scss']
})
export class IntegrationLanguagesSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
